import './App.css';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Partners from './components/Partners/Partners';
import Products from './components/Products/Products';
import Why from './components/Why/Why';
import Join from './components/Join/Join';
import Brand from './components/Brand/Brand';
import HeaderSecond from './components/HeaderSeconde/HeaderSecond';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Map from './components/Map/Map';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.body.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.body.lang = i18n.language;
  }, [i18n.language]);

  return (
    <>
      <Hero />
      <About />
      <Partners />
      <Products />
      <Why />
      <Join />
      <Brand />
      <HeaderSecond />
      <Map />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
